import { Injectable, inject } from '@angular/core';
import { BaseParamsService } from './base-params.service';
import { Angulartics2 } from 'angulartics2';
import storage from 'local-storage-fallback';

@Injectable({
  providedIn: 'root',
})
export class MemberIdKeeperService {
  private baseParamsService = inject(BaseParamsService);
  private angulartics = inject(Angulartics2);

  private readonly MEMBER_ID_LOCAL_STORAGE_KEY = 'mid';
  private lastPushedMemberId: number | null = null;

  public saveMemberId(memberId: number): void {
    this.notifyAnalytics(memberId);
    storage.setItem(this.localStorageKey(), memberId.toString());
  }

  public readMemberId(): number | null {
    const id = storage.getItem(this.localStorageKey());
    if (id == null) { return null; }

    return +id;
  }

  public clearMemberId(): void {
    this.notifyAnalytics(null);
    storage.removeItem(this.localStorageKey());
  }

  private localStorageKey(): string {
    return `${this.MEMBER_ID_LOCAL_STORAGE_KEY}-${this.baseParamsService.slug}`;
  }

  private notifyAnalytics(memberId: number | null): void {
    if (memberId === this.lastPushedMemberId) { return; }

    this.lastPushedMemberId = memberId;
    this.angulartics.eventTrack.next({
      action: 'member_id_update',
      properties: { category: 'member_id_change', label: 'MemberID Fetched', gtmCustom: { memberId: memberId } },
    });
  }
}
